module.exports = __webpack_public_path__ + "static/author-ade11e20a7b10ea108ab3cdab9f9edaa.png";